import { Component, inject } from '@angular/core';
import { IonButton, IonContent, IonIcon, ModalController } from '@ionic/angular/standalone';

@Component({
  selector: 'app-ban-modal',
  template: `
    <ion-content class="ban-modal">
      <div class="ban-wrapper">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <h2>Access Restricted</h2>
        <p>{{ message }}</p>
        <ion-button fill="solid" color="dark" (click)="dismiss()">OK</ion-button>
      </div>
    </ion-content>
  `,
  styles: [
    `
      .ban-modal {
        --background: #000;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .ban-wrapper {
        text-align: center;
        padding: 2rem;
        max-width: 300px;
        margin: auto;
      }
      ion-icon {
        font-size: 4rem;
        color: #f8b400;
        margin-bottom: 1rem;
      }
      ion-button {
        margin-top: 1.5rem;
      }
    `,
  ],
  standalone: true,
  imports: [IonContent, IonIcon, IonButton],
})
export class BanModalComponent {
  private modalCtrl: ModalController = inject(ModalController);
  message = "You've hit a temporary limit. Please try again later.";

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
